/* Nutraviva collection grid.
   Adds to cart straight from the card. A product with more than one size slides
   its sizes up over the foot of its own photo instead of opening a dialog, so
   the page is never taken over and the product stays in view. Posts to
   /cart/add.js directly rather than going through the theme's product-form
   element, which expects markup this card deliberately does not have. */
(function () {
  function drawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* Only ever one open at a time, so two cards can't both be asking. */
  function closeQuick(except) {
    document.querySelectorAll('[data-nv-quick]').forEach(function (q) {
      if (q === except) return;
      q.hidden = true;
      var card = q.closest('.nv-card');
      var btn = card && card.querySelector('[data-nv-choose]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function openQuick(card, btn) {
    var q = card.querySelector('[data-nv-quick]');
    if (!q) return false;
    closeQuick(q);
    q.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    var first = q.querySelector('.nv-quick__size');
    if (first) first.focus({ preventScroll: true });
    return true;
  }

  function addToCart(id, btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var label = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = btn.getAttribute('data-nv-adding') || 'Adding…';

    var d = drawer();
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (d && typeof d.getSectionsToRender === 'function') {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { throw new Error(res.description || res.message); }
        if (d && typeof d.renderContents === 'function') {
          if (typeof d.setActiveElement === 'function') d.setActiveElement(btn);
          d.renderContents(res);
          if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
        } else {
          window.location.href = '/cart';
          return;
        }
        btn.textContent = btn.getAttribute('data-nv-added') || 'Added';
        setTimeout(function () {
          btn.textContent = label;
          btn.removeAttribute('aria-disabled');
          closeQuick(null);
        }, 1100);
      })
      .catch(function () {
        /* Never leave the shopper on a dead button: fall back to the cart page. */
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function (e) {
    var choose = e.target.closest('[data-nv-choose]');
    if (choose) {
      var card = choose.closest('.nv-card');
      if (!card) return;
      var q = card.querySelector('[data-nv-quick]');
      /* Pressing the button again puts the sizes away. */
      if (q && !q.hidden) {
        q.hidden = true;
        choose.setAttribute('aria-expanded', 'false');
      } else {
        openQuick(card, choose);
      }
      return;
    }

    var add = e.target.closest('[data-nv-add]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-nv-add'), add);
      return;
    }

    /* A click anywhere else puts an open picker away. */
    if (!e.target.closest('[data-nv-quick]')) closeQuick(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-nv-quick]:not([hidden])');
    if (!open) return;
    var card = open.closest('.nv-card');
    var btn = card && card.querySelector('[data-nv-choose]');
    closeQuick(null);
    if (btn) btn.focus();
  });
})();
